import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import Api from '../api/Api';
import useAuthStore from '../store/authStore';
import { usePointStore } from '../store/pointStore';
import { QUERY_KEYS } from './queryKeys';

export const useInitPoint = () => {
  const isAuthenticated = useAuthStore((state) => state.user?.authenticated ?? false);
  const setFWEPoints = usePointStore((state) => state.setFWEPoints);
  const setInSituPoints = usePointStore((state) => state.setInSituPoints);

  const fweQuery = useQuery({
    queryKey: [QUERY_KEYS.map.fwePoints],
    queryFn: async () => {
      if (!isAuthenticated) return [];

      return await Api.FWEPoint.getFWEPoints();
    },
    enabled: isAuthenticated,
  });

  const insituQuery = useQuery({
    queryKey: [QUERY_KEYS.map.insituPoints],
    queryFn: async () => {
      if (!isAuthenticated) return [];

      return await Api.insituPoint.getInsituPoints();
    },
    enabled: isAuthenticated,
  });

  useEffect(() => {
    if (fweQuery.data) {
      setFWEPoints(fweQuery.data);
    }
  }, [fweQuery.data, setFWEPoints]);

  useEffect(() => {
    if (insituQuery.data) {
      setInSituPoints(insituQuery.data);
    }
  }, [insituQuery.data, setInSituPoints]);
};
